import request from '../utils/request'

export function businessRequest() {
    return request({
        url: 'dashboard/business',
        method: 'get'
    })
}

export function savedRequest(data) {
    return request({
        url: 'dashboard/save/business',
        method: 'post',
        data
    })
}

export function updateRequest(data) {
    return request({
        url: 'dashboard/update/business',
        method: 'post',
        data
    })
}

